import useUnmountOrUnload from '../useUnmountOrUnload';
import { useAnalyticsActions } from '../../containers/redux/withAnalytics';
import { analyticsPayload } from '../../lib/analytics';

const useSendImpressions = () => {
  const { logEvent } = useAnalyticsActions();

  useUnmountOrUnload(() =>
    logEvent({ analytics: analyticsPayload.impressions() })
  );
};

export default useSendImpressions;
